export class PageHeaderURL {
  public static EndPoints = {
    page: {
      getAuthorizedPages:
        '/platform/page-designer/page/organization/{orgid}?returnUserPage=true&excludeNoActiveVersionPages=true&isEnable=true'
    }
  };
}
